/**
 * Formats an LLM-generated sentiment theme for display.
 *
 * Themes arrive from the summarizer model in arbitrary casing (e.g.
 * "parking issues"). This title-cases each word for the admin UI while
 * leaving the underlying stored value untouched. Known acronyms are
 * preserved in their canonical casing rather than naively title-cased
 * (e.g. "hvac" -> "HVAC", not "Hvac").
 */

// Lowercased token -> canonical display form.
const ACRONYMS: Record<string, string> = {
  hvac: "HVAC",
  wifi: "WiFi",
  hoa: "HOA",
  ac: "AC",
  tv: "TV",
};

export function displayTheme(theme: string): string {
  // Split on whitespace runs, keeping the separators so spacing is preserved.
  return theme
    .split(/(\s+)/)
    .map((token) => {
      if (token.length === 0 || /^\s+$/.test(token)) return token;
      const acronym = ACRONYMS[token.toLowerCase()];
      if (acronym) return acronym;
      return token[0].toUpperCase() + token.slice(1).toLowerCase();
    })
    .join("");
}
